<script setup>
import { defineProps } from "vue";
defineProps({
  title: {
    type: String,
    required: true,
  },
  subTitle: {
    type: String,
  },
  maxWidth: {
    type: Boolean,
    default: false,
    required: false,
  },
});
</script>
<template>
  <div
    class="bg-gradient-to-r from-app-primary flex flex-col gap-2 to-app-secondary"
  >
    <div
      class="w-full flex flex-col gap-2 sm:px-6 mx-auto lg:px-8 py-3"
      :class="{
        '': maxWidth,
      }"
    >
      <div class="w-full">
        <h1 class="text-2xl font-heading font-semibold text-white">
          {{ title }}
        </h1>
        <p v-if="subTitle" class="mt-1 text-sm text-white/80">
          {{ subTitle }}
        </p>
      </div>
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
